import Link from 'next/link'

import { Text } from '@wartek-id/text-v1'
import { Button } from '@wartek-id/button-v1'
import { Icon } from '@wartek-id/icon-v2'

import useToggleSdkContext from 'utils/useToogleSdk'
import { PengelolaanKinerjaTimeline } from 'app/KinerjaShared/components/PengelolaanKinerjaTimeline'
import KinerjaSidebar from 'app/KinerjaShared/components/KinerjaSidebar'
import { assetUrl } from 'utils/url'
import { PENGELOLAAN_KINERJA_GPK_TIM_KINERJA_PATH } from 'app/KinerjaShared/constants/path'
import { PANDUAN_PENGELOLAAN_URL } from 'app/KinerjaShared/utils/panduan'

export function Homepage() {
  const toggles = useToggleSdkContext()
  const isPemantauanPelaksanaanEnabled =
    toggles?.['kinerja-gpk-pemantauan-pelaksanaan-enabled'] === true

  return (
    <div className="flex w-full min-h-screen">
      <div className="flex-shrink-0 min-h-full">
        <div className="w-64">{/* Sentinel element for sidebar spacing */}</div>
        <KinerjaSidebar activeMenu="gpk-tim-kinerja" sticky />
      </div>
      <div className="w-full gap-4 p-6 space-y-6">
        {/* Perencanaan entrypoint */}
        <section className="shadow-card rounded-lg p-6 bg-white">
          <div className=" flex items-center justify-between gap-6">
            <div className="flex items-center gap-6">
              <img
                alt=""
                src={assetUrl('/images/img-typing-monitor.png')}
                width={84}
                height={84}
                className="flex-shrink-0"
              />
              <div>
                <Text variant="heading-lg" as="h2" className="mb-1">
                  Periksa Perencanaan Kinerja
                </Text>
                <Text color="subdued">
                  Cek Perencanaan yang sudah diajukan oleh Guru Pendidikan
                  Khusus. Persetujuan Perencanaan akan dilakukan oleh Pejabat
                  Penilai Kinerja.
                </Text>
              </div>
            </div>
            <Link
              href={`${PENGELOLAAN_KINERJA_GPK_TIM_KINERJA_PATH}/perencanaan`}
              passHref
            >
              <Button
                size="lg"
                as="a"
                type={undefined}
                color="black"
                className="min-w-60 whitespace-nowrap"
              >
                Periksa
              </Button>
            </Link>
          </div>

          <div className="rounded bg-cyan-5 p-3 mt-6 flex items-center">
            <Icon color="informational" className="mr-1">
              error
            </Icon>
            Jika satuan pendidikan tidak sesuai, mohon kunjungi&nbsp;
            <a
              className="!text-blue-70 underline"
              href={PANDUAN_PENGELOLAAN_URL}
              target="_blank"
              rel="noreferrer"
            >
              Pusat Bantuan
            </a>
            .
          </div>
        </section>

        {/* Pelaksanaan entrypoint */}
        {isPemantauanPelaksanaanEnabled && (
          <section className="shadow-card rounded-lg p-6 bg-white">
            <div className=" flex items-center justify-between gap-6">
              <div className="flex items-center gap-6">
                <img
                  alt=""
                  src={assetUrl('/illustrations/img-book-rapor-graphic.png')}
                  width={84}
                  height={84}
                  className="flex-shrink-0"
                />
                <div>
                  <Text variant="heading-lg" as="h2" className="mb-1">
                    Pemantauan Kinerja dan Rekomendasi Predikat Kinerja
                  </Text>
                  <Text color="subdued">
                    Lakukan untuk seluruh Guru Pendidikan Khusus di satuan
                    pendidikan Anda.
                  </Text>
                </div>
              </div>
              <Link
                href={`${PENGELOLAAN_KINERJA_GPK_TIM_KINERJA_PATH}/pelaksanaan`}
                passHref
              >
                <Button
                  size="lg"
                  as="a"
                  type={undefined}
                  color="black"
                  className="min-w-60 whitespace-nowrap"
                >
                  Lakukan
                </Button>
              </Link>
            </div>
          </section>
        )}

        <PengelolaanKinerjaTimeline
          timeline={[
            {
              title: 'Januari',
              steps: ['Perencanaan Kinerja'],
            },
            {
              title: 'Februari - November',
              steps: [
                'Persiapan Praktik Kinerja',
                'Pelaksanaan Observasi Praktik Kinerja',
                'Pelaksanaan Tindak Lanjut Praktik Kinerja',
              ],
            },
            {
              title: 'Desember',
              steps: ['Rekomendasi Predikat Kinerja'],
            },
          ]}
        />
      </div>
    </div>
  )
}
